import type { JourneyPlanTimeMode } from '../../../../../data/journeyPlanSearch';
import { Input } from '../../../../base/Input/Input';
import styles from './JourneyTimeSelector.module.css';

const timeModeOptions: Array<{
  value: JourneyPlanTimeMode;
  label: string;
}> = [
  { value: 'now', label: 'Leave now' },
  { value: 'leaveAt', label: 'Leave at...' },
  { value: 'arriveBy', label: 'Arrive by...' },
];

function joinClassNames(...classNames: Array<string | false>) {
  return classNames.filter(Boolean).join(' ');
}

interface JourneyTimeSelectorProps {
  mode: JourneyPlanTimeMode;
  dateValue: string;
  timeValue: string;
  onModeChange: (mode: JourneyPlanTimeMode) => void;
  onDateChange: (value: string) => void;
  onTimeChange: (value: string) => void;
}

export function JourneyTimeSelector({
  mode,
  dateValue,
  timeValue,
  onModeChange,
  onDateChange,
  onTimeChange,
}: JourneyTimeSelectorProps) {
  const showDateTimeInputs = mode === 'leaveAt' || mode === 'arriveBy';

  return (
    <div className={styles.container}>
      <div className={styles.buttonGroup}>
        {timeModeOptions.map((option) => (
          <button
            key={option.value}
            type="button"
            className={joinClassNames(
              styles.toggleButton,
              mode === option.value && styles.active,
            )}
            onClick={() => onModeChange(option.value)}
          >
            {option.label}
          </button>
        ))}
      </div>

      {showDateTimeInputs && (
        <div className={styles.dateTimeRow}>
          <Input
            type="date"
            value={dateValue}
            onInput={(event) =>
              onDateChange((event.currentTarget as HTMLInputElement).value)
            }
          />
          <Input
            type="time"
            value={timeValue}
            onInput={(event) =>
              onTimeChange((event.currentTarget as HTMLInputElement).value)
            }
          />
        </div>
      )}
    </div>
  );
}
